/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getViewSubGroupsState, setViewSubGroupsState} from '../utils/helpers';

export interface UseViewSubGroupsParams {
  name: string;
  action: Function;
  view: boolean;
  preference?: string
};

/**
 * useViewSubGroups hook used to update the value for viewSubGroups
 * used by all the grids
 *
 * ```typescript
 *
 * import {useViewSubGroups} from '@ion/applications/src/hooks/useViewSubGroups';
 *
 * const [viewSubGroups, toggleViewSubGroups] = useViewSubGroups();
 * ```
 */
export const useViewSubGroups = ({name, action, view = false, preference = ''}: UseViewSubGroupsParams) => {
  const dispatch                             = useDispatch();
  const includeSubGroups                     = useSelector(({[name]: {grid}}) => grid?.includeSubGroups) ||
  getViewSubGroupsState(preference);
  const [viewSubGroups, toggleViewSubGroups] = useState(includeSubGroups || view);

  useEffect(() => {
    dispatch(action(viewSubGroups));
    if (preference && includeSubGroups !== viewSubGroups) {
      setViewSubGroupsState(preference, viewSubGroups);
    }
  }, [view, viewSubGroups]);

  return [
    viewSubGroups,
    toggleViewSubGroups
  ];
};

export default useViewSubGroups;
